import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Button } from "@material-ui/core";
import docService from "../../Services/docsService";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import adminService from "../../Services/adminService";
import Autocomplete from "@material-ui/lab/Autocomplete";

import Swal from "sweetalert2";

class AdminDocsManager extends Component {
  state = {
    docName: "",
    docKey: "",
    isDocActive: false,
    docBelongsToTabs: [],
    docBelongsToPackages: [],
    focusedPackagesTabsData: [],
    editExistingDoc: "",
    newSelectedDoc: null
  };

  componentDidMount() {
    docService.getDocsTabs(true).then((res) => {
      if (res["success"]) {
        var tabs = res["tabsFromDB"];
        var docsList = res["docsList"];

        this.setState({ tabs, docsList });
      }
    });
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <h3 className="yellow-color">הוספת או עריכה של מסמך למערכת</h3>
            <div className="mb-40">
              <TextField id="docName" label="שם מסמך" onChange={this.handleChange} value={this.state.docName} />
              <div className="mt-20">
                {this.state.docKey ? (
                  <TextField id="docKey" disabled label="קוד מסמך" value={this.state.docKey} />
                ) : null}
              </div>
              <div className="mt-20">
                {this.state.tabs
                  ? this.state.tabs.map((tab, index) => {
                      return (
                        <FormControlLabel
                          key={tab.sectionName}
                          className="align-checkbox-opts"
                          control={<Checkbox value={tab.sectionName} color="primary" />}
                          label={tab.sectionName}
                          onChange={this.docBelongToTabChanged}
                          checked={this.state.docBelongsToTabs.includes(tab.sectionName)}
                          name={tab.sectionName}
                        />
                      );
                    })
                  : null}
              </div>

              {this.state.focusedPackagesTabsData && this.state.focusedPackagesTabsData[0] ? (
                <div className="mt-20">
                  <span className="yellow-color">
                    ה-TAB שנבחר למסמך מכיל PACKAGES. יש לבחור לאיזה PACKAGE המסמך החדש שייך
                  </span>
                  <div className="mt-20">
                    {this.state.focusedPackagesTabsData.map((focusedPackageOption, index) => {
                      return (
                        <div key={focusedPackageOption.sectionName} className="mt-20 bordered">
                          אפשרויות ה-PACKAGES של <b className="primary-color">{focusedPackageOption.sectionName}</b>
                          <div className="mt-20">
                            {focusedPackageOption.packages.map((focusPackage, index) => {
                              return (
                                <FormControlLabel
                                  key={focusPackage.packageName + index}
                                  className="align-checkbox-opts"
                                  control={<Checkbox value={focusPackage.packageName} color="primary" />}
                                  label={focusPackage.packageName}
                                  onChange={this.fileBelongToInnerPackageChange}
                                  checked={this.state.docBelongsToPackages.includes(focusPackage.packageName)}
                                />
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}

              {this.state.editExistingDoc ? null : (
                <div className="mt-20">
                  בחר מסמך
                  <br />
                  <input type="file" onChange={this.onFileChange} />
                  {this.state.newSelectedDoc ? (
                    <i onClick={this.removeSelectedFile} className="material-icons width40 pointer">
                      cancel
                    </i>
                  ) : null}
                </div>
              )}

              <div className="mt-20">
                <Button onClick={this.saveAllDocChanges} color="primary" variant="contained">
                  שמור שינוים
                </Button>

                {!this.state.editExistingDoc ? (
                  <Button className="mr-20" onClick={this.testDoc} color="secondary" variant="contained">
                    בדוק מסמך
                  </Button>
                ) : null}
              </div>
            </div>
          </div>

          <div className="col-sm-5">
            <h3 className="primary-color">עריכת מסמך קיים</h3>

            {this.state.docsList && this.state.docsList[0] ? (
              <div>
                <Autocomplete
                  className="custom-autocomplete"
                  options={this.state.docsList}
                  getOptionLabel={(option) => option.aliasName}
                  style={{ width: 300 }}
                  renderInput={(params) => <TextField {...params} label="מסמכים שקיימים במערכת" variant="outlined" />}
                  onInputChange={(event, newInputValue) => {
                    this.handExistingDocChange(newInputValue);
                  }}
                />
              </div>
            ) : null}
            <div className="mt-50">
              {this.state.docKey ? (
                <Button className="mr-20" onClick={this.deleteDoc} color="secondary" variant="contained">
                  מחק מסמך
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  removeSelectedFile = () => {
    this.state.pointerToRemoveFile.value = null;
    this.setState({ newSelectedDoc: null, pointerToRemoveFile: null });
  };

  deleteDoc = () => {
    adminService.adminSetDocDeleted(this.state.docKey).then((res) => {
      if (res["success"]) {
        Swal.fire("doc was set to status deleted", "", "success");
      } else {
        Swal.fire("Something went wrong", "", "warning");
      }
    });
  };

  // When we choose which tab the new doc belongs to then we will check if that tab has packages and show them as well.
  docBelongToTabChanged = (e) => {
    var copyDocBelongsToTabs = [...this.state.docBelongsToTabs];
    var getPackagesToRemove = null;
    if (e.target.checked) {
      copyDocBelongsToTabs.push(e.target.value);
    } else {
      // Remove all possibly clicked packages within a tab if the doc does not longer belong to that tab.
      getPackagesToRemove = this.state.tabs.filter((item) => item.sectionName === e.target.value)[0].packages || [];
      var docBelongsToPackages = [...this.state.docBelongsToPackages];
      docBelongsToPackages = docBelongsToPackages.filter((item) => {
        for (const inner of getPackagesToRemove) {
          if (inner.packageName === item) return false;
        }
        return true;
      });

      // remove the checkbox from the unselected tab
      copyDocBelongsToTabs = copyDocBelongsToTabs.filter((item) => item !== e.target.value);
    }

    // we need additional data on the tabs which are of type package and also currently checked in the UI. lets get them
    var focusedPackagesTabsData = this.state.tabs.filter((item) => {
      return item.sectionType === "package" && copyDocBelongsToTabs.includes(item.sectionName);
    });

    var stateJsonChanges = { docBelongsToTabs: copyDocBelongsToTabs, focusedPackagesTabsData };
    if (docBelongsToPackages) stateJsonChanges["docBelongsToPackages"] = docBelongsToPackages;
    this.setState(stateJsonChanges);
  };

  fileBelongToInnerPackageChange = (e) => {
    var copyDocBelongsToPackages = [...this.state.docBelongsToPackages];

    if (e.target.checked) copyDocBelongsToPackages.push(e.target.value);
    else copyDocBelongsToPackages = copyDocBelongsToPackages.filter((item) => item !== e.target.value);

    this.setState({ docBelongsToPackages: copyDocBelongsToPackages });
  };

  onFileChange = (e) => {
    this.setState({ newSelectedDoc: e.target.files[0], pointerToRemoveFile: e.target });
  };

  handExistingDocChange = (docAliasName) => {
    var docBelongsToTabs = [];
    var docBelongsToPackages = [];
    var docName = docAliasName;
    var docKey = "";

    // get document aliasName
    for (const doc of this.state.docsList) {
      if (doc.aliasName === docAliasName) {
        docKey = doc.nameWithExtension;
        break;
      }
    }

    for (const tab of this.state.tabs) {
      if (tab.sectionType === "regular") {
        for (const tabDocItem of tab.docsList) {
          if (tabDocItem.nameWithExtension === docKey) {
            docBelongsToTabs.push(tab.sectionName);
            break;
          }
        }
      } else {
        // tab of type package
        for (const currentPackage of tab.packages) {
          for (const tabDocItem of currentPackage.docsList) {
            if (tabDocItem.nameWithExtension === docKey) {
              if (!docBelongsToTabs.includes(tab.sectionName)) docBelongsToTabs.push(tab.sectionName);
              docBelongsToPackages.push(currentPackage.packageName);
              break;
            }
          }
        }
      }
    }
    var focusedPackagesTabsData = this.state.tabs.filter((item) => {
      return item.sectionType === "package" && docBelongsToTabs.includes(item.sectionName);
    });
    this.setState({
      docBelongsToTabs,
      docBelongsToPackages,
      focusedPackagesTabsData,
      editExistingDoc: docKey,
      docKey,
      docName
    });
  };

  testDoc = () => {
    if (!this.state.newSelectedDoc) {
      Swal.fire("", "לא נבחר קובץ להעלאה", "warning");
      return;
    }

    var selectedFile = this.state.newSelectedDoc;
    var fd = new FormData();
    fd.append("doc", selectedFile, selectedFile.name);
    adminService.adminTestDoc(fd).then((res) => {
      if (res["success"]) {
        Swal.fire("Success", res["tags"].join(" , "), "success");
      } else {
        var errsArr = res["properties"]["errors"];
        var errMsgToPrint = "";
        for (const err of errsArr) {
          errMsgToPrint += `<div style="text-align:left"><b style="color:blue">Error type:</b> ${err.properties.id}.<br/> <b style="color:blue">explanation:</b> ${err.properties.explanation}<br/><br/></div>`;
        }
        Swal.fire({ title: "Failed", html: errMsgToPrint, icon: "warning" });
      }
    });
  };

  saveAllDocChanges = () => {
    var state = this.state;
    if (!state.docName) {
      Swal.fire("", "לא ניתן לשמור ללא שם מסמך וקוד מסמך", "warning");
      return;
    }

    if (!state.editExistingDoc && !state.newSelectedDoc) {
      Swal.fire("", "לא נבחר קובץ להעלאה", "warning");
      return;
    }

    var selectedFile = state.newSelectedDoc;
    var fd = new FormData();
    if (selectedFile) {
      var docAliasName;
      if (state.docName) {
        docAliasName = selectedFile.name.split(".");
        docAliasName = state.docName + "." + docAliasName[docAliasName.length - 1];
      }
      fd.append("doc", selectedFile, docAliasName || selectedFile.name);
    }
    var queryForPost = `?docKey=${state.docKey}&docBelongsToTabs=${state.docBelongsToTabs.join(
      ":"
    )}&docBelongsToPackages=${state.docBelongsToPackages.join(":")}`;

    if (state.editExistingDoc) {
      queryForPost += "&isEditExisting=" + true;
      if (state.docName) {
        queryForPost += "&docName=" + state.docName;
      }
    }

    adminService.adminUpdateDoc(fd, queryForPost).then((res) => {
      if (res["success"]) {
        Swal.fire("", "Image added successfully", "success");
        this.setState({ focusImgUrl: res["imageUrl"] });
      }
    });
  };
}

export default AdminDocsManager;
